// extracted by mini-css-extract-plugin
export default {"selectBox":"Kaigu","container":"IlQYh","isSelected":"ra2Z_"};